import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'de',
    lng: 'de',
    debug: true,
    ns: ['sentence','commonde', 'commonen', 'illusmaker'],  // Declare your namespaces here
    defaultNS: 'commonde',  // Fallback namespace (optional)
    interpolation: {
      escapeValue: false, 
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',  // Load each file based on namespace
    },
  });

export default i18n;
